import { Fragment } from 'react'

import { useETEditorFormikPoolingType } from 'services/event_types'

import { UserPoolListItem } from './user_pool_list_item'
import { getUserPoolUid } from '../../helpers'
import { useRemoveUserPool, useUserPoolsData } from '../../hooks'
import { ListWrapper } from '../styles'

export const UserPoolsList = ({ eventType, isLocked, wrapped = false, hidden = false }) => {
  const onRemoveUserPool = useRemoveUserPool(eventType)

  const { isRoundRobin, isCollectiveRoundRobin } = useETEditorFormikPoolingType()

  const {
    roundRobinUserPools,
    hasRoundRobinUserPools,
    isLastUserPool
  } = useUserPoolsData()

  if (!hasRoundRobinUserPools || hidden) { return null }

  const Wrapper = wrapped
    ? (props) => <ListWrapper isLocked={isLocked} {...props} />
    : Fragment

  if (isRoundRobin) {
    return (
      <Wrapper>
        <UserPoolListItem
          eventType={eventType}
          isLocked={isLocked}
        />
      </Wrapper>
    )
  }

  if (isCollectiveRoundRobin) {
    return (
      <Wrapper>
        {roundRobinUserPools.map((pool) => (
          <UserPoolListItem
            key={getUserPoolUid(pool)}
            eventType={eventType}
            userPool={pool}
            isLastUserPool={isLastUserPool}
            isLocked={isLocked}
            onRemove={onRemoveUserPool}
          />
        ))}
      </Wrapper>
    )
  }

  return null
}
